import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';

import { useAppSelector } from '../../store';
import TruncatedTableCell from '../truncated-table-cell';

const ReportGridTable = (): any => {
    const { groupTitleGridTable } = useAppSelector(state => state.momentReports);
    
    return (
        <div className="c-item-03">
            <TableContainer component={Paper} className="showcase-01">
                <Table className="container-table" aria-label="simple table">
                    <TableHead className="table-header">
                        <TableRow className="table-header-row">
                            {!groupTitleGridTable?.loading &&
                                groupTitleGridTable?.headerList?.map((item, index) => (
                                    <TableCell
                                        className="table-header-item-01"
                                        key={'header-item-' + index}
                                        style={{ minWidth: item?.columnSize && item?.columnSize > 0 ? item?.columnSize : 200 }}
                                    >
                                        <Typography variant="inherit" noWrap>
                                            {item?.header}
                                        </Typography>
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody className="table-body">
                        {!groupTitleGridTable?.loading &&
                            groupTitleGridTable?.rowList?.map((rows, index) => {
                                return (
                                    <TableRow key={'rows-' + index} className="table-body-row">
                                        {rows?.dataList?.map((item, index__) => (
                                            <TableCell
                                                key={'item-' + index__}
                                                component="th"
                                                align="left"
                                                scope="row"
                                                className="table-body-item-01"
                                            >
                                                {groupTitleGridTable?.headerList[index__]?.isTruncated ? (
                                                    <TruncatedTableCell
                                                        text={item?.data}
                                                        truncatedSize={groupTitleGridTable?.headerList[index__]?.truncatedSize}
                                                    />
                                                ) : (
                                                    <Typography variant="inherit">
                                                        {item?.data}
                                                    </Typography>
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default ReportGridTable;
